export default {
    'modifyProfile.member_profile': '會員資料',
    'modifyProfile.error.modify_fail': '修改失敗，請重試',
    'modifyProfile.error.different_phone_number': '請輸入與之前不同的手機號碼',
    'modifyProfile.modify': '修改',
    'modifyProfile.submit': '送出修改',
} as Record<string, string>;
